import type { Modulo } from '@scm/contratos';

/**
 * Las vistas de la plataforma, como dato.
 *
 * La nav se dibuja desde aqui, no se escribe a mano: un grupo cuyos items
 * estan todos ocultos por permisos NO se dibuja, y eso solo sale bien si la
 * nav se deriva de una estructura en vez de ser markup.
 */

export interface Vista {
  /** Ruta, que es tambien el identificador. */
  ruta: string;
  /** Nombre corto para el menu. */
  n: string;
  /** Titulo largo para el pagehead. */
  t: string;
  /** Descripcion para el crumb. */
  s: string;
  /** Icono: emoji, como el estandar. */
  ic: string;
  modulo: Modulo;
}

export interface GrupoVistas {
  g: string;
  items: Vista[];
}

export const VISTAS: GrupoVistas[] = [
  {
    g: 'Tablero',
    items: [
      {
        ruta: '/',
        n: 'Resumen',
        t: 'Resumen ejecutivo',
        s: 'Operacion del dia, SLA y saldo contratado',
        ic: '▦',
        modulo: 'MOD_TABLERO',
      },
      {
        ruta: '/torre',
        n: 'Torre de control',
        t: 'Torre de control',
        s: 'Desviaciones vigentes, lo mas urgente primero',
        ic: '🛫',
        modulo: 'MOD_TORRE',
      },
    ],
  },
  {
    g: 'Analitica',
    items: [
      {
        ruta: '/analitica',
        n: 'SLA y periodo',
        t: 'Analitica del periodo',
        s: 'Cumplimiento de SLA, consumo y causales en el tiempo',
        ic: '📈',
        modulo: 'MOD_TABLERO',
      },
      {
        ruta: '/consulta',
        n: 'Consulta pivote',
        t: 'Consulta pivote',
        s: 'Cruza cualquier dimension contra cualquier medida',
        ic: '⊞',
        modulo: 'MOD_CONSULTA',
      },
    ],
  },
  {
    g: 'Operacion de campo',
    items: [
      {
        ruta: '/tickets',
        n: 'Tickets',
        t: 'Tickets y despacho',
        s: 'Servicios en curso y su programacion',
        ic: '🎫',
        modulo: 'MOD_TICKETS',
      },
      {
        ruta: '/sitios',
        n: 'Sitios',
        t: 'Sitios',
        s: 'Padron de sitios por cliente',
        ic: '📍',
        modulo: 'MOD_SITIOS',
      },
    ],
  },
  {
    g: 'Comercial',
    items: [
      {
        ruta: '/clientes',
        n: 'Clientes',
        t: 'Clientes',
        s: 'Cuentas y contactos',
        ic: '🏢',
        modulo: 'MOD_CLIENTES',
      },
      {
        ruta: '/contratos',
        n: 'Contratos',
        t: 'Contratos y saldo',
        s: 'Volumen contratado y consumo',
        ic: '📄',
        modulo: 'MOD_CONTRATOS',
      },
      {
        ruta: '/proyectos',
        n: 'Proyectos',
        t: 'Proyectos',
        s: 'Avance, ventana operativa y alcance',
        ic: '📁',
        modulo: 'MOD_PROYECTOS',
      },
      {
        ruta: '/biblioteca',
        n: 'Biblioteca',
        t: 'Biblioteca del proyecto',
        s: 'Manuales, planos y procedimientos',
        ic: '📚',
        modulo: 'MOD_PROYECTOS',
      },
    ],
  },
  {
    g: 'Ingenieria',
    items: [
      {
        ruta: '/idc',
        n: 'IDC',
        t: 'IDC',
        s: 'Plantilla de ingenieros de campo',
        ic: '🤝',
        modulo: 'MOD_IDC',
      },
    ],
  },
  {
    g: 'Inventario',
    items: [
      {
        ruta: '/existencias',
        n: 'Existencias',
        t: 'Existencias',
        s: 'Saldo por almacen y articulo',
        ic: '📦',
        modulo: 'MOD_INVENTARIO',
      },
      {
        ruta: '/resguardos',
        n: 'Resguardos',
        t: 'Resguardos de IDC',
        s: 'Que trae encima cada ingeniero',
        ic: '🎒',
        modulo: 'MOD_INVENTARIO',
      },
      {
        ruta: '/guias',
        n: 'Guias',
        t: 'Guias entre almacenes',
        s: 'Envios, transito y recepcion',
        ic: '🚚',
        modulo: 'MOD_INVENTARIO',
      },
      {
        ruta: '/rastreo',
        n: 'Rastreo',
        t: 'Rastreo de articulos',
        s: 'Por guia, numero de serie o numero de parte',
        ic: '🔍',
        modulo: 'MOD_INVENTARIO',
      },
      {
        ruta: '/movimientos',
        n: 'Movimientos',
        t: 'Movimientos de inventario',
        s: 'El libro: entradas, salidas y ajustes',
        ic: '📜',
        modulo: 'MOD_INVENTARIO',
      },
    ],
  },
  {
    g: 'Second touch',
    items: [
      {
        ruta: '/staging',
        n: 'Tablero',
        t: 'Second touch',
        s: 'Como va el proceso, de la recepcion a la entrega',
        ic: '🏭',
        modulo: 'MOD_STAGING',
      },
      {
        ruta: '/recepciones',
        n: 'Recepciones',
        t: 'Recepciones de pallets',
        s: 'La llegada del equipo virgen y su conteo',
        ic: '📦',
        modulo: 'MOD_STAGING',
      },
      {
        ruta: '/equipos',
        n: 'Padron',
        t: 'Padron de equipos',
        s: 'Serie por serie, de virgen a instalado',
        ic: '🖥',
        modulo: 'MOD_STAGING',
      },
      {
        ruta: '/remesas',
        n: 'Remesas',
        t: 'Remesas de carga',
        s: 'Una imagen, un lote, una evidencia',
        ic: '💽',
        modulo: 'MOD_STAGING',
      },
      {
        ruta: '/embarque',
        n: 'Embarque',
        t: 'Embarque a sitios',
        s: 'Una guia por sitio con lo que esta listo',
        ic: '🚚',
        modulo: 'MOD_STAGING',
      },
    ],
  },
  {
    g: 'Catalogos',
    items: [
      {
        ruta: '/catalogos',
        n: 'Catalogos',
        t: 'Catalogos',
        s: 'Lo que se elige de una lista',
        ic: '🗂',
        modulo: 'MOD_CATALOGOS',
      },
    ],
  },
  {
    g: 'Sistema',
    items: [
      {
        ruta: '/ajustes',
        n: 'Ajustes',
        t: 'Ajustes',
        s: 'Los umbrales con los que la torre decide que avisar',
        ic: '⚙',
        modulo: 'MOD_AJUSTES',
      },
      {
        ruta: '/auditoria',
        n: 'Auditoria',
        t: 'Auditoria',
        s: 'Quien hizo que, cuando y con que valores',
        ic: '🧾',
        modulo: 'MOD_AUDITORIA',
      },
    ],
  },
];

/** Busca la vista de una ruta, para el pagehead. */
export function vistaDe(ruta: string): Vista | undefined {
  const exacta = VISTAS.flatMap((g) => g.items).find((v) => v.ruta === ruta);
  if (exacta) return exacta;
  /* Un detalle (/tickets/TKT-...) hereda el encabezado de su lista. */
  return VISTAS.flatMap((g) => g.items)
    .filter((v) => v.ruta !== '/' && ruta.startsWith(v.ruta))
    .sort((a, b) => b.ruta.length - a.ruta.length)[0];
}
